module.exports = __webpack_public_path__ + "img/us2.17e3de22.png";